import { render } from "./UtentiCms.vue?vue&type=template&id=da0f6dbc"
import script from "./UtentiCms.vue?vue&type=script&lang=js"
export * from "./UtentiCms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__